import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Info = makeShortcode("Info");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Info mdxType="Info">
Uniswap V1, while still fully functional, is no longer under active development. Looking for <Link to='/docs/v2/' mdxType="Link">V2 documentation</Link>?
    </Info>
    <p>{`It is possible that a token you are interested in is not included in the token dropdown on `}<a parentName="p" {...{
        "href": "https://app.uniswap.org/#/swap?use=v1"
      }}>{`https://app.uniswap.org/#/swap?use=v1`}</a>{`, however, all tokens that have a deployed uniswap exchange are supported on the front-end.`}</p>
    <p>{`There are three ways to interact with tokens that are not yet included on the default list.`}</p>
    <h2 {...{
      "id": "1-paste-the-token-address-into-the-search-box",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#1-paste-the-token-address-into-the-search-box",
        "aria-label": "1 paste the token address into the search box permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`1. Paste the token address into the search box.`}</h2>
    <p>{`If a token is not included in the list, try pasting the token address into the search box. It will populate the dropdown with the token you are looking for.`}</p>
    <h2 {...{
      "id": "2-custom-linking",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#2-custom-linking",
        "aria-label": "2 custom linking permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`2. Custom Linking`}</h2>
    <p><a parentName="p" {...{
        "href": "https://app.uniswap.org/#/swap?use=v1"
      }}>{`https://app.uniswap.org/#/swap?use=v1`}</a>{` supports custom linking to all tokens that have a Uniswap exchange. See `}<Link to='/docs/v1/frontend-integration/custom-linking' mdxType="Link">{`Custom Linking`}</Link>{` for details on how to link.`}</p>
    <p>{`For example, to populate the output token field with an unlisted token, we can specify the outputCurrency in the URL and pass in the token’s address like this:`}</p>
    <p><inlineCode parentName="p">{`https://app.uniswap.org/#/swap?use=v1?outputCurrency=0xfA3E941D1F6B7b10eD84A0C211bfA8aeE907965e`}</inlineCode></p>
    <h2 {...{
      "id": "3-make-a-request-to-get-your-token-listed",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#3-make-a-request-to-get-your-token-listed",
        "aria-label": "3 make a request to get your token listed permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`3. Make a request to get your token listed`}</h2>
    <p>{`For tokens that have high market caps, high liquidity provision, or high trading volume, you can fill out a `}<a parentName="p" {...{
        "href": "https://docs.google.com/forms/d/e/1FAIpQLSdQMI4KnQ1lCB0aiwzQ8xGTL59EX5FtkF6f2nT-JeQcxpW2Sw/formResponse"
      }}>{`request to be added to the dropdown menu`}</a></p>
    <h2 {...{
      "id": "token-details-and-assets",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#token-details-and-assets",
        "aria-label": "token details and assets permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Token Details and Assets`}</h2>
    <p>{`Token information (including decimals, symbol, name, etc.) is pulled from token contracts directly. Logo images are pulled from TrustWallet. If you’d like your token logo updated make a pull request into the TrustWallet assets repo `}<a parentName="p" {...{
        "href": "https://github.com/trustwallet/assets"
      }}>{`https://github.com/trustwallet/assets`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      